// extracted by mini-css-extract-plugin
export default {"showSider":"sider_showSider__qLzrJ","sider":"sider_sider__rhnzc","hiddenSider":"sider_hiddenSider__TGwad"};